import React from 'react'
import { format } from 'date-fns'

import { Availability } from '../../types'

import * as S from './styles'

type ScheduleTimeItemProps = {
  availability: Availability
  setSelectedSchedule: (availability: Availability) => void
  selectedSchedule: Availability
  isEmpty: boolean
}

export const ScheduleTimeItem: React.FC<ScheduleTimeItemProps> = ({
  availability,
  setSelectedSchedule,
  selectedSchedule,
  isEmpty
}) => {
  return (
    <S.Item
      disabled={isEmpty}
      onClick={() => setSelectedSchedule(availability)}
      active={selectedSchedule?.startDate === availability.startDate}
    >
      <strong>
        {isEmpty ? 'XX:XX': format(new Date(availability.startDate), 'HH:mm')}
      </strong>
    </S.Item>
  )
}